import React from 'react';
import PropTypes from 'prop-types';

import { TreeNodeDatumShape } from '../propTypes';

const DEFAULT_NODE_CIRCLE_RADIUS = 15;

const textLayout = {
  title: {
    textAnchor: 'start',
    x: 40,
  },
  attribute: {
    x: 40,
    dy: '1.2em',
  },
};

function DefaultNodeElement({ nodeDatum, toggleNode, onNodeClick, onNodeMouseOver, onNodeMouseOut }) {
  return (
    <>
      <circle
        r={DEFAULT_NODE_CIRCLE_RADIUS}
        onClick={(evt) => {
          toggleNode();
          onNodeClick(evt);
        }}
        onMouseOver={onNodeMouseOver}
        onMouseOut={onNodeMouseOut}
      />
      <g className="rd3t-label">
        <text className="rd3t-label__title" {...textLayout.title}>
          {nodeDatum.name}
        </text>
        <text className="rd3t-label__attributes">
          {nodeDatum.attributes &&
            // eslint-disable-next-line custom/no-unsafe-deep-access
            Object.entries(nodeDatum.attributes).map( ([labelKey, labelValue]) => (
              <tspan key={`${labelKey}-${labelValue}`} {...textLayout.attribute}>
                {labelKey}: {labelValue}
              </tspan>
            ))}
        </text>
      </g>
    </>
  );
}

DefaultNodeElement.propTypes = {
  nodeDatum: TreeNodeDatumShape.isRequired,
  toggleNode: PropTypes.func.isRequired,
  onNodeClick: PropTypes.func.isRequired,
  onNodeMouseOver: PropTypes.func.isRequired,
  onNodeMouseOut: PropTypes.func.isRequired,
};

export default DefaultNodeElement;
